import { React } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { PATH } from '../../../constants';

import { sortByConfidenceDesc } from '../../../utils';

const ListLinks = ({ links, type }) => {
    const listLinkClasses = classNames('list-links', {
        'list-links--large': type === 'large'
    });
    const sortedLinks = sortByConfidenceDesc(links);
    const linkElements = sortedLinks.map((link) => (
        <li key={link.id} className="list-links__item">
            <Link
                className="list-links__link link"
                to={`${PATH.helpAndSupport}/${link.categoryId}/${link.id}`}
            >
                {link.name}
            </Link>
        </li>
    ));

    return (
        <ul
            className={listLinkClasses}
        >
            {linkElements}
        </ul>
    );
};

export default ListLinks;
